import { render, staticRenderFns } from "./RestoreLocationPopup.vue?vue&type=template&id=0033ebbc&scoped=true&"
import script from "./RestoreLocationPopup.vue?vue&type=script&lang=ts&"
export * from "./RestoreLocationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreLocationPopup.vue?vue&type=style&index=0&id=0033ebbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033ebbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0033ebbc')) {
      api.createRecord('0033ebbc', component.options)
    } else {
      api.reload('0033ebbc', component.options)
    }
    module.hot.accept("./RestoreLocationPopup.vue?vue&type=template&id=0033ebbc&scoped=true&", function () {
      api.rerender('0033ebbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/RestoreLocationPopup.vue"
export default component.exports